import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'sg-game-dialog',
  templateUrl: './game-dialog.component.html',
  styleUrls: ['./game-dialog.component.scss']
})
export class GameDialogComponent {

  @Output() gameDialogChange = new EventEmitter();

}
